export const light = {
  colors: {
    paleta: {
      verde: '#4CAF50',
      amarelo: '#FFEB3B',
      branco: '#FFFFFF',
      laranja: '#FF9800',
      azul: '#1565C0',
      vermelho: '#F44336',
      cinza: '#E0E0E0',
    },
    primary: {
      normal: '#E0E0E0',
    },
    dark: {
      background: '#F1F1F1',
      main: '#607EAA',
      text: '#6e6b7b',
      cardText: "#f3f4f8",
      input: '#f3f4f8',
      json: '#0F3460',
      default: '#283046',
    },
    card: {
      background: "#6E85B7",
      text: "",
      border: '#A760FF',
    },
    button: {
      main: '#f3f4f8',
      hover: '#65b5f6'
    },
    menu: {
      active: '#89CFFD',
      statusCard: '#F1EFDC'
    },
    title: '#0096FF'
  }
}